import { CircularProgress, Stack } from '@mui/material';

export default function Disconnecting(): JSX.Element {
  return (
    <Stack flexGrow="1" justifyContent="center" alignItems="center">
      <CircularProgress />
    </Stack>
  );
}
